module.exports = __webpack_public_path__ + "static/media/cnito_web_play.29663094.png";